import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { LazyImage } from '@edusense/shared-ui-kit';
import { MediaPreview } from './styles/UserChatMessage.styles';
export const MessageMedia = ({ mediaUrl, contentType })=>{
    if (!mediaUrl) return null;
    const isImage = contentType?.startsWith('image/');
    const isVideo = contentType?.startsWith('video/');
    return /*#__PURE__*/ _jsxs(MediaPreview, {
        children: [
            isImage && /*#__PURE__*/ _jsx(LazyImage, {
                src: mediaUrl,
                alt: "Shared image",
                aspectRatio: "16/9",
                style: {
                    maxWidth: '100%',
                    borderRadius: '0.5rem'
                }
            }),
            isVideo && /*#__PURE__*/ _jsx("video", {
                src: mediaUrl,
                controls: true,
                preload: "metadata",
                style: {
                    maxWidth: '100%',
                    borderRadius: '0.5rem'
                },
                role: "presentation"
            })
        ]
    });
};
